"use client";

/**
 * DiscoveryAnalytics 컴포넌트
 * @description 홈이 열렸음을 한 번 남긴다. 페이지뷰는 SDK 가 스스로 남기지만, 이 이벤트가
 *   있어야 홈에서 시작하는 퍼널(배너 · 카드 · 앱 받기)의 분모가 잡힌다. 그리지 않는다.
 */
import { useEffect, useRef } from "react";

import { trackDiscoveryViewed } from "../../analytics";

export function DiscoveryAnalytics() {
  const hasTracked = useRef(false);

  useEffect(() => {
    if (hasTracked.current) return;
    hasTracked.current = true;
    trackDiscoveryViewed();
  }, []);

  return null;
}
